"use strict";import{Tabs as e}from"./src/Tabs.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-tabs",e);
//# sourceMappingURL=sp-tabs.js.map
